import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=60cd83ab&scoped=true&"
import script from "./PartnersPage.vue?vue&type=script&lang=js&"
export * from "./PartnersPage.vue?vue&type=script&lang=js&"
import style0 from "./PartnersPage.vue?vue&type=style&index=0&id=60cd83ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cd83ab",
  null
  
)

export default component.exports